module.exports = {"350604001":"石码街道","350604100":"海澄镇","350604101":"角美镇","350604102":"白水镇","350604103":"浮宫镇","350604104":"程溪镇","350604105":"港尾镇","350604106":"九湖镇","350604107":"颜厝镇","350604108":"榜山镇","350604109":"紫泥镇","350604110":"东园镇","350604200":"东泗乡","350604201":"隆教畲族乡","350604400":"双第华侨农场","350604401":"九龙岭林场","350604402":"程溪农场","350604403":"良种场","350604405":"林下林场","350604501":"招商局漳州开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350604.json
// module id = 1321
// module chunks = 0